<template>
  <div class="maccontainer _maccontainer">
   <NavTop :navid = id />
   <div class="home_box">
       <img v-lazy="backimg" alt="" class="julihe_bannerimg">
       <div class="article_box">
           <div class="article_title" style="margin-bottom:1vh;">成功案例</div>
           <div class="anli_box">
               <img v-lazy="item.more.thumbnail" v-for="item in anlilist" :key="item.id" alt="" class="anli_img">
           </div>
        </div>
   </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import {getcontactmebackimg, getanlilist} from '../../api/jslihe'
export default {
  name: 'mac',
  components: {
    NavTop
  },
  data () {
    return {
      id: Number(this.$route.query.id),
      backimg: '',
      anlilist: []
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      getcontactmebackimg({id: 15}).then(res => {
        console.log(res)
        this.backimg = res.data.more.thumbnail
      })
      getanlilist({limit: 100, category_id: 15}).then(Response => {
        console.log(Response)
        this.anlilist = Response.data.list
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .anli_box{
   .anli_img{
     width:60%;
     margin-bottom:1vh;
      transition: all 0.8s linear;
      margin-top:1vh;
   }
   .anli_img:hover{
transform: scale(1.2);
transition: all 0.8s linear;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Watch/Watch.vue